import { Box, Stack } from '@mui/material';
import { useNavigate } from 'react-router';

import { selectCurrentProjectTour } from '@/domain/project-tour/project-tour.selectors';
import { selectProjectTourOnTourCurrentSequence } from '@/domain/project-tour-ontour/project-tour-ontour.selectors';
import { PageTitle } from '@/ui/components/PageTitle';
import { useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';

import { SequenceOverview } from './sequence-overview/SequenceOverview';
import { TourTravelsAndDates } from './travels-and-dates/TourTravelsAndDates';
import { TourVariousCost } from './various-cost/TourVariousCost';

export function TourOnTour() {
  const navigate = useNavigate();

  const project = useAppSelector(selectCurrentProjectTour);
  const sequence = useAppSelector(selectProjectTourOnTourCurrentSequence);

  if (!project || !sequence) {
    return null;
  }

  const onClickBack = () => {
    const params = new URLSearchParams();
    params.set('mode', 'co2');
    params.set('submode', 'ontour');
    navigate(`/app/projects/tour/${project?.id}?${params.toString()}`);
  };

  const VIEW_WIDTH = '70rem';

  return (
    <Stack>
      <PageTitle
        title={`${translate('ProjectsTour.project-tour-ontour')} : ${sequence.name}`}
        backButtonText={project.name}
        onClickBack={onClickBack}
      />
      <Stack sx={{ mt: 2, gap: 5 }}>
        <Box sx={{ width: VIEW_WIDTH }}>
          <SequenceOverview sequenceId={sequence.id} />
        </Box>
        <Box sx={{ width: VIEW_WIDTH }}>
          <TourTravelsAndDates sequenceId={sequence.id} />
        </Box>
        <Box sx={{ width: VIEW_WIDTH }}>
          <TourVariousCost sequenceId={sequence.id} />
        </Box>
      </Stack>
    </Stack>
  );
}
